import { Box, MenuItem, Select, TextField } from '@mui/material';
import React from 'react';
import { useAuthStore } from '../../store/storeAuth';
import Label from '../UI/Label/Label';
import MicrosoftFileSelect from './MicrosoftFileSelect';
import { SlideOptions } from '../GoogleSlidesIntegration/PushGoogleSlidesData';

interface PushMicrosoftPowerPointDataProps {
  formData: any;
  onChange: (e: { target: { name: string; value: any } }) => void;
  onChangeSelect: (e: { target: { name: string; value: any } }) => void;
  data: any;
  nodeId: string;
  nodeLabel: string;
}

const PushMicrosoftPowerPointData: React.FC<PushMicrosoftPowerPointDataProps> = ({
  formData,
  onChange,
  onChangeSelect,
  data,
}) => {
  const { user } = useAuthStore(state => state);

  const fileId = data?.microsoftPowerPointFileId ?? '';
  const selectedSlideOption =
    formData.selectedSlideOption ?? SlideOptions.APPEND;

  const selectSx = {
    width: '100%',
    '& .MuiList-root': {
      backgroundColor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
    },
    '& .MuiSvgIcon-root': {
      color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
    },
    borderRadius: '8px',
    border: 'none',
    boxShadow: 'none',
    '.MuiOutlinedInput-notchedOutline': { border: 0 },
    bgcolor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
    color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
  };

  const menuPropsSx = {
    PaperProps: {
      sx: {
        '& .Mui-selected': {
          backgroundColor: user?.theme === 'dark' ? '#667085' : '#D0D5DD',
        },
        backgroundColor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
      },
    },
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <MicrosoftFileSelect
        fileType="pptx"
        fileIdField="microsoftPowerPointFileId"
        label="presentations"
        selectLabel="Search or select a PowerPoint file"
        onChangeSelect={onChangeSelect}
        data={data}
      />

      {!fileId && (
        <Box>
          <Label
            isAdvanced
            labelStyle={{
              fontSize: '14px',
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
              fontWeight: 400,
            }}
            labelName="New Presentation Name"
          />
          <TextField
            placeholder="Presentation Name"
            onChange={onChange}
            value={formData.newPresentationName ?? ''}
            name="newPresentationName"
            fullWidth
            InputProps={{
              style: {
                color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
              },
            }}
            sx={{
              marginTop: '8px',
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
              bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
              border: `2px solid ${
                user?.theme === 'dark' ? '#475467' : '#EAECF0'
              }`,
            }}
          />
        </Box>
      )}

      {fileId && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Label
            labelStyle={{
              fontSize: '14px',
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
              fontWeight: 400,
            }}
            labelName="Option"
            isAdvanced
          />
          <Select
            value={selectedSlideOption}
            onChange={e =>
              onChangeSelect({
                target: {
                  name: 'selectedSlideOption',
                  value: e.target.value as SlideOptions,
                },
              })
            }
            className="nodrag"
            sx={{ ...selectSx, marginTop: 0 }}
            MenuProps={menuPropsSx}
          >
            {Object.values(SlideOptions).map(opt => (
              <MenuItem
                key={opt}
                value={opt}
                sx={{ color: user?.theme === 'dark' ? '#D0D5DD' : 'black' }}
              >
                {opt}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    </Box>
  );
};

export default PushMicrosoftPowerPointData;
